import { Injectable, inject } from "@angular/core";
import { TemplateLocaleService } from "@domain/project/template";
import { Country } from "@domain/user/locale/country";
import { LanguageMap } from "@domain/user/locale/language";
import { LanguageHelper } from "@domain/user/locale/language-helper";
import { UserService } from "@domain/user/user.service";
import { Observable, first, map, switchMap } from "rxjs";

@Injectable({ providedIn: "root" })
export class UserLocaleService {
  private templateLocaleService = inject(TemplateLocaleService);
  private userService = inject(UserService);
  private languageHelper = inject(LanguageHelper);

  readonly supportedCountries$: Observable<Country[]> = this.userService.user$.pipe(
    first(),
    switchMap((user) =>
      this.templateLocaleService
        .getCountryCodesByScope(user.scope)
        .pipe(map((codes) => codes.map((code) => ({ countryCode: code })))),
    ),
  );

  readonly supportedLanguages$: Observable<LanguageMap[]> = this.userService.user$.pipe(
    first(),
    switchMap((user) =>
      this.templateLocaleService
        .getLanguageCodesByScope(user.scope)
        .pipe(map((codes) => this.languageHelper.buildLanguageMapsFromCodes(codes))),
    ),
  );
}
